import { SAO_PAULO_OFFSET, SAO_PAULO_TIMEZONE } from './saoPauloDateTime'

export const ENROLLMENT_VISIBLE_STATUSES = ['Ativa', 'Inativada', 'Expirada']
export const ENROLLMENT_ACCESSIBLE_STATUSES = ['Ativa']
export const ENROLLMENT_BLOCKED_STATUSES = ['Inativada', 'Expirada']
export const MANUAL_ENROLLMENT_STATUSES = ['Ativa', 'Inativada', 'Cancelada']

function getSaoPauloDatePart(value) {
  try {
    return new Intl.DateTimeFormat('sv-SE', {
      timeZone: SAO_PAULO_TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(value)
  } catch {
    return ''
  }
}

export function getEnrollmentExpirationEndOfDay(expiresAt) {
  if (!expiresAt) return null
  const expiresAtDate = new Date(expiresAt)
  if (Number.isNaN(expiresAtDate.getTime())) return null
  const datePart = getSaoPauloDatePart(expiresAtDate)
  if (!datePart) return null
  const endOfDay = new Date(`${datePart}T23:59:59.999${SAO_PAULO_OFFSET}`)
  return Number.isNaN(endOfDay.getTime()) ? null : endOfDay
}

export function isEnrollmentExpired(expiresAt, now = new Date()) {
  const expirationDate = getEnrollmentExpirationEndOfDay(expiresAt)
  if (!expirationDate) return false
  const nowDate = now instanceof Date ? now : new Date(now)
  if (Number.isNaN(nowDate.getTime())) return false
  return expirationDate.getTime() < nowDate.getTime()
}

export function formatEnrollmentExpiresAt(expiresAt, options = {}) {
  const {
    includeTime = true,
    year = 'numeric',
  } = options
  const expirationDate = getEnrollmentExpirationEndOfDay(expiresAt)
  if (!expirationDate) return ''
  return expirationDate.toLocaleString('pt-BR', {
    timeZone: SAO_PAULO_TIMEZONE,
    day: '2-digit',
    month: '2-digit',
    year,
    ...(includeTime ? {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    } : {}),
  })
}

export function formatEnrollmentExpiresAtTime(expiresAt) {
  const expirationDate = getEnrollmentExpirationEndOfDay(expiresAt)
  if (!expirationDate) return ''
  return expirationDate.toLocaleTimeString('pt-BR', {
    timeZone: SAO_PAULO_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
}

export function buildEnrollmentExpirationAtIso(durationDays, referenceDate = new Date()) {
  const parsedDays = Number.parseInt(durationDays, 10)
  if (!Number.isFinite(parsedDays) || parsedDays <= 0) return null
  const baseDate = referenceDate instanceof Date ? referenceDate : new Date(referenceDate)
  if (Number.isNaN(baseDate.getTime())) return null
  const projectedDate = new Date(baseDate.getTime() + (parsedDays * 24 * 60 * 60 * 1000))
  return getEnrollmentExpirationEndOfDay(projectedDate)?.toISOString() || null
}

export function normalizeEnrollmentStatus(status, expiresAt) {
  const rawStatus = String(status || '').trim()
  if (!rawStatus) return ''

  if (rawStatus === 'Cancelada' || rawStatus === 'Inativada') {
    return rawStatus
  }

  if (rawStatus === 'Expirado' || rawStatus === 'Expirada') {
    return isEnrollmentExpired(expiresAt) ? 'Expirada' : 'Ativa'
  }

  if (rawStatus === 'Confirmada' || rawStatus === 'Ativa' || rawStatus === 'Pendente') {
    return isEnrollmentExpired(expiresAt) ? 'Expirada' : 'Ativa'
  }

  return rawStatus
}

export function getPersistedEnrollmentStatus(status, expiresAt) {
  const normalizedStatus = normalizeEnrollmentStatus(status, expiresAt)

  if (normalizedStatus === 'Ativa') return 'Confirmada'
  if (normalizedStatus === 'Expirada') return 'Expirado'
  return normalizedStatus
}

export function isEnrollmentAccessBlocked(status) {
  return ENROLLMENT_BLOCKED_STATUSES.includes(String(status || '').trim())
}
